// extracted by mini-css-extract-plugin
export default {"edit_your_box":"Vi","edit_box_title":"Wi","subscription":"Xi","byb":"Yi","recommended_for_you_title":"Zi","explore":"aj","recommended":"bj","go_back":"cj","wrapper":"ej","product_img":"fj","info":"gj","remove_btn":"hj"};
    if(module.hot) {
      // 1715091664214
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  